import React, { useState } from 'react';
import { Box, Button, Container, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SidebarType } from '../../../lib/types/types';
import OrganisationData from './content/organisation-data/OrganisationData';
// import NutzerVerwaltung from './content/nutzerverwaltung/NutzerVerwaltung';
import Contents from '../../../components/ui-component/mein-bereich/Contents';
import SideBars from '../../../components/ui-component/mein-bereich/Sidebars';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function MeineOrganisation() {
	const navigate = useNavigate();
	const [activesideBar, setActiveSideBar] = useState<number>(0);
	const sidebars: SidebarType = [
		{ label: 'Meine Organisation', element: <OrganisationData /> },
		// { label: 'Nutzerverwaltung', element: <NutzerVerwaltung /> },
	];
	const toggleSideBarButton = (_event: React.SyntheticEvent, newSideBarButton: number) => {
		setActiveSideBar(newSideBarButton);
	};
	return (
		<Container>
			<Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'center', md: 'flex-start' }}>
				<Box>
					<Button
						variant="outlined"
						startIcon={<ArrowBackIcon />}
						onClick={() => {
							navigate('/mein-bereich');
						}}
						sx={{ m: '1rem 2rem 1rem 0', minWidth: '16.4rem' }}
					>
						Zurück zu Mein Bereich
					</Button>
					<SideBars sidebars={sidebars} activeSideBarButton={activesideBar} toggleSideBarButton={toggleSideBarButton} />
				</Box>

				<Contents sidebars={sidebars} activeSideBarButton={activesideBar} />
			</Stack>
		</Container>
	);
}

export default MeineOrganisation;
